var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.791 4.253h-.001m0 0A6.406 6.406 0 0012 4a6.413 6.413 0 00-1.79.253m3.58 0c2.41.7 4.188 2.778 4.326 5.27m-7.906-5.27c-2.51.73-4.335 2.953-4.335 5.583v3.431c0 .683-.875 1.072-.875 1.899 0 .46.392.834.875.834h12.25c.483 0 .875-.373.875-.834M10.21 4.253h-.001M19 15.166c0-.581-.447-.955-.702-1.369m.702 1.37c0-.592-.447-.959-.702-1.37m-.173-.53V9.836a5.056 5.056 0 00-.009-.312m.009 3.743a1 1 0 00.173.53m-.173-.53c0 .195.071.366.173.53m-.182-4.273a5.637 5.637 0 00-.008-.125M10 19c.208.516 1.024 1.5 2 1.5s1.792-.984 2-1.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBell;